import React from "react";

const IconCampusFilled = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M8 15.594V19H6v-4.607L2.013 12 12 5.995 22.004 12l-9.995 6L8 15.594z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default IconCampusFilled;
